import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProdutoList.css';
import api from '../services/api';
import { toast } from 'react-toastify';

function FornecedorForm() {
  const navigate = useNavigate();

  const [razao_social, setRazaoSocial] = useState('');
  const [nome_fantasia, setNomeFantasia] = useState('');
  const [email, setEmail] = useState('');
  const [telefone, setTelefone] = useState('');
  const [cnpj, setCnpj] = useState('');
  const [endereco, setEndereco] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    const data = { razao_social, nome_fantasia, email, telefone, cnpj, endereco };
    const token = localStorage.getItem('access_token');
    const headers = { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
    try {
      await api.post('/fornecedores/', data, { headers });
      toast.success('Fornecedor cadastrado com sucesso!');
      navigate('/fornecedores');
    } catch {
      toast.error('Erro ao cadastrar o fornecedor.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="produto-page">

      <div className="produto-page-header">
        <div className="produto-page-title-row">
          <h2 className="produto-page-title">Fornecedores</h2>
          <div className="produto-tabs">
            <span className="produto-tab active">Novo Fornecedor</span>
            <span className="produto-tab" onClick={() => navigate('/fornecedores')}>
              Lista de Fornecedores
            </span>
          </div>
        </div>
      </div>

      <div className="prd-card prd-form-card">
        <div className="prd-card-accent" />
        <div className="prd-form-body">
          <header className="prd-form-header">
            <h3 className="prd-form-title">Informações do Fornecedor</h3>
            <p className="prd-form-sub">Preencha os dados para cadastrar um novo fornecedor.</p>
          </header>

          <form onSubmit={handleSubmit}>
            <div className="prd-form-left">
              <div className="prd-form-row3" style={{ gridTemplateColumns: '1fr 1fr' }}>
                <div className="prd-field">
                  <label className="prd-label">Razão Social</label>
                  <input
                    className="prd-input"
                    type="text"
                    placeholder="Razão social da empresa"
                    value={razao_social}
                    onChange={(e) => setRazaoSocial(e.target.value)}
                    required
                  />
                </div>
                <div className="prd-field">
                  <label className="prd-label">Nome Fantasia</label>
                  <input
                    className="prd-input"
                    type="text"
                    placeholder="Nome fantasia (opcional)"
                    value={nome_fantasia}
                    onChange={(e) => setNomeFantasia(e.target.value)}
                  />
                </div>
              </div>

              <div className="prd-form-row3" style={{ gridTemplateColumns: '1fr 1fr 180px' }}>
                <div className="prd-field">
                  <label className="prd-label">Email</label>
                  <input
                    className="prd-input"
                    type="email"
                    placeholder="contato@fornecedor.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="prd-field">
                  <label className="prd-label">Telefone</label>
                  <input
                    className="prd-input"
                    type="text"
                    placeholder="(00) 00000-0000"
                    value={telefone}
                    onChange={(e) => setTelefone(e.target.value)}
                  />
                </div>
                <div className="prd-field">
                  <label className="prd-label">CNPJ</label>
                  <input
                    className="prd-input"
                    type="text"
                    placeholder="00.000.000/0000-00"
                    value={cnpj}
                    onChange={(e) => setCnpj(e.target.value)}
                  />
                </div>
              </div>

              <div className="prd-field prd-field--full">
                <label className="prd-label">Endereço</label>
                <input
                  className="prd-input"
                  type="text"
                  placeholder="Rua, nº, bairro, cidade, estado"
                  value={endereco}
                  onChange={(e) => setEndereco(e.target.value)}
                />
              </div>
            </div>

            <div className="prd-form-actions" style={{ gridColumn: 'unset', marginTop: '1.5rem' }}>
              <button
                type="button"
                className="prd-btn-cancel"
                onClick={() => navigate('/fornecedores')}
              >
                Cancelar
              </button>
              <button type="submit" className="prd-btn-save" disabled={saving}>
                <span className="material-symbols-outlined">save</span>
                {saving ? 'Salvando...' : 'Cadastrar Fornecedor'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default FornecedorForm;
